<template>
  <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.74222 1.55472L9.18753 4.00003M9.18753 4.00003L6.74222 6.44534M9.18753 4.00003H0.81247" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: "ArrowRight"
}
</script>